import IProductGroup from './IProductGroup';
import IProductGroupListItem from './list/IProductGroupListItem';
import Api from '../../shared/Api';

class ProductGroupsApi {
    static getProductGroups(): any {
        return new Promise<any>(
            (resolve: (result: IProductGroupListItem) => void, reject: (errors: any[]) => void) => {
                new Api()
                    .get('/views/productgroups')
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static createProductGroup(productGroup: any): Promise<any> {
        return new Promise<any>(
            (resolve: (result: IProductGroupListItem) => void, reject: (errors: any) => void) => {
                new Api()
                    .post('/views/productgroups', productGroup)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static newProductGroup(): Promise<any> {
        return new Promise<any>(
            (resolve: (result: IProductGroup) => void, reject: (errors: any[]) => void) => {
                new Api()
                    .get('/views/productgroups/new')
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static loadEditProductGroup(id: number): any {
        return new Promise<any>(
            (resolve: (response: IProductGroup) => void, reject: (error: any) => void) => {
                new Api()
                    .get(`/views/productgroups/${id}/edit`)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static updateProductGroup(productGroup: any): Promise<any> {
        return new Promise<any>(
            (resolve: (result: IProductGroupListItem) => void, reject: (errors: any) => void) => {
                new Api()
                    .put(`/views/productgroups/${productGroup.id}`, productGroup)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static deleteProductGroup(id: number): any {
        return new Promise<any>((resolve: () => void, reject: (error: any) => void) => {
            new Api()
                .delete(`/views/productgroups/${id}`)
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }
}

export default ProductGroupsApi;
